import styled from 'styled-components';

export const InputContainer = styled.div`
  position: relative;
`;

export const RightAdornmentContainer = styled.div<{ hasError: boolean }>`
  position: absolute;
  bottom: ${props => (props.hasError ? '18px' : '4px')};
  right: 0px;
  z-index: 3;
`;
